export const TIMELINE_FORCE_REFRESH_EVENT = 'timeline:force-refresh';

export type TimelineForceRefreshAction = 'update' | 'delete' | 'emotion' | 'rethread' | 'create';

export type TimelineForceRefreshPayload = {
  collectionPath: string;
  action: TimelineForceRefreshAction;
  docId?: string;
  patch?: Record<string, any>;
};

export function emitTimelineForceRefresh(payload: TimelineForceRefreshPayload) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(TIMELINE_FORCE_REFRESH_EVENT, { detail: payload }),
  );
}

